import { useMemo } from "react";
import { useDispatch, useSelector } from "react-redux";
import Modal from "../common/Modal";
import Table from "../common/Table";
import Button from "../common/Button";
import Card from "../common/Card";
import { removeHeldOrder } from "../../store/heldOrdersSlice";

const formatHeldAt = (value) => {
  if (!value) return "-";
  const date = new Date(value);
  if (Number.isNaN(date.getTime())) return "-";
  return date.toLocaleString();
};

const HeldOrdersModal = ({ isOpen, onClose, onResume }) => {
  const dispatch = useDispatch();
  const heldOrders = useSelector((state) => state.heldOrders.orders) || [];

  const columns = [
    { key: "customer", label: "Customer", headerClassName: "pl-1", cellClassName: "pl-1" },
    { key: "mode", label: "Type", headerClassName: "w-[110px]" },
    { key: "heldAt", label: "Held At", headerClassName: "w-[190px]" },
    {
      key: "actions",
      label: "Actions",
      headerClassName: "w-[220px] text-right pr-1",
      cellClassName: "text-right pr-1",
    },
  ];

  const rows = useMemo(() => {
    return heldOrders.map((order) => ({
      id: order.id,
      customer: (
        <div className="space-y-0.5">
          <div className="font-semibold text-slate-900 dark:text-slate-100">
            {order.customerName || "Customer"}
          </div>
          <div className="text-xs text-slate-500 dark:text-slate-400">
            {order.customerPhone || "-"}
          </div>
        </div>
      ),
      mode: order.mode || "-",
      heldAt: formatHeldAt(order.heldAt),
      actions: (
        <div className="flex w-full items-center justify-end gap-2 whitespace-nowrap pr-1">
          <Button
            size="sm"
            variant="secondary"
            onClick={() => dispatch(removeHeldOrder(order.id))}
          >
            Remove
          </Button>
          <Button
            size="sm"
            onClick={() => {
              const resumePath = order.resumePath || "/pos";
              dispatch(removeHeldOrder(order.id));
              onResume && onResume(resumePath, order);
              onClose && onClose();
            }}
          >
            Resume
          </Button>
        </div>
      ),
    }));
  }, [dispatch, heldOrders, onClose, onResume]);

  return (
    <Modal
      isOpen={isOpen}
      onClose={onClose}
      title={null}
      size="xl"
      backdropClassName="bg-black/25 backdrop-blur-sm"
    >
      <div className="space-y-3">
        <div className="flex items-center justify-between gap-2">
          <div>
            <div className="text-base font-semibold text-slate-900 dark:text-slate-100">
              Held Orders
            </div>
            <div className="text-xs text-slate-500 dark:text-slate-400">
              Resume an order that was held from POS.
            </div>
          </div>
          <div className="flex items-center gap-2">
            <Button size="sm" variant="secondary" onClick={onClose}>
              Close
            </Button>
          </div>
        </div>

        <Card className="bg-white/70 dark:bg-slate-900/30">
          <Table columns={columns} rows={rows} emptyText="No held orders." />
        </Card>
      </div>
    </Modal>
  );
};

export default HeldOrdersModal;
